import Vue from 'vue';
import LoadScript from 'vue-plugin-load-script';
import router from '@/router';
import store from '@/store';
import VueAnalytics from 'vue-ua';
import App from '@/components/App';

Vue.use(LoadScript);
Vue.config.productionTip = false;

if (process.env.VUE_APP_UA_TOKEN) {
  Vue.use(VueAnalytics, {
    appName: 'beneficiaries-site',
    appVersion: '2.6.0',
    trackingId: `${process.env.VUE_APP_UA_TOKEN}`,
    debug: process.env.NODE_ENV !== 'production',
  });
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
